import { Axios } from 'axios'
import { createContext, useContext } from 'react'

export type AuthedAxiosRequests = Omit<Axios, 'interceptors' | 'defaults'>

export type GeckoLogoutParams = {
  returnTo?: string
}

export type GeckoAuthenticationContextType = {
  authorization: string | undefined
  authorizedAxios: AuthedAxiosRequests
  isAuthenticated: boolean
  logout: (geckoLogoutParams: GeckoLogoutParams) => void
}

/** A context providing useful authentication/authorization information */
export const GeckoAuthenticationContext = createContext<
  GeckoAuthenticationContextType | undefined
>(undefined)

export const useGeckoAuthentication = (): GeckoAuthenticationContextType => {
  const context = useContext(GeckoAuthenticationContext)
  if (!context)
    throw new Error(
      'useGeckoAuthentication() must be used within GeckoAuthenticationContext'
    )
  return context
}
